import React from 'react';
import { getComputedCSSVariable } from '../../utils/cssVariableHelpers';

interface Props {
  color?: string,
  style?: object,
}

const CompassSVG: React.FC<Props> = ({
  color,
  style,
}) => {
  return (
    <span
      className="d-flex svg-wrapper"
      style={style}
    >
      <svg
        version="1.1"
        id="Layer_1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        x="0px"
        y="0px"
        viewBox="0 0 64 64"
        xmlSpace="preserve"
      >
        <desc>A line styled icon from Orion Icon Library.</desc>
        <g>
          <path fill={color} className="st0" d="M30,54c-0.1,0-0.2,0-0.4,0c-0.9-0.2-1.6-0.9-1.6-1.8l-1.1-15.1L11.9,36c-0.9-0.1-1.7-0.7-1.8-1.6 c-0.2-0.9,0.3-1.8,1.1-2.2l34-16c0.8-0.4,1.7-0.2,2.3,0.4s0.8,1.5,0.4,2.3l-16,34C31.5,53.6,30.8,54,30,54z M19.8,32.6l9.2,0.7 c1,0.1,1.8,0.9,1.9,1.9l0.7,9.2l10.4-22L19.8,32.6z" />
        </g>
        <g>
          <path fill={color} className="st0" d="M32,64C14.4,64,0,49.6,0,32C0,14.4,14.4,0,32,0c17.6,0,32,14.4,32,32C64,49.6,49.6,64,32,64z M32,4 C16.6,4,4,16.6,4,32s12.6,28,28,28s28-12.6,28-28S47.4,4,32,4z" />
        </g>
      </svg>
    </span>
  );
};

CompassSVG.defaultProps = {
  color: getComputedCSSVariable('black'),
  style: {
    width: '12px',
    height: '12px',
  },
};

export default CompassSVG;
